import { useCallback, useEffect, useMemo, useState } from 'react';

import { useGetCreatedForOthersTrainings } from '../../../../redux/api/trainingsAPI';
import { orderBy } from '../../../../utils/collections/array-utils';

const SEARCH_DEBOUNCE_MS = 1000;

export function useFromMeTrainingsPage() {
  const [filter, setFilter] = useState('');
  const [debouncedFilter, setDebouncedFilter] = useState('');

  useEffect(() => {
    const id = window.setTimeout(() => {
      setDebouncedFilter(filter);
    }, SEARCH_DEBOUNCE_MS);
    return () => clearTimeout(id);
  }, [filter]);

  const {
    data: trainings,
    isLoading,
    isFetching,
    isUninitialized,
    error,
    refetch,
  } = useGetCreatedForOthersTrainings({ searchValue: debouncedFilter });

  const orderedTrainings = useMemo(
    () => (trainings ? orderBy(trainings, 'createdAt') : null),
    [trainings],
  );

  const isListLoading = Boolean(
    (isLoading && !isUninitialized) || (isFetching && !trainings?.length),
  );

  const refetchAll = useCallback(async () => {
    await refetch();
  }, [refetch]);

  return {
    trainings: orderedTrainings,
    filter,
    setFilter,
    isLoading: isListLoading,
    error,
    refetchAll,
  };
}
